<template>
  <v-app>
    <div v-if="this.userDisplayName!='Gäst'">
    <schedule v-model="Schedule" />
    <Settings :As="this.As" v-model="Setting" />
    <!-- <Notification :As="this.As" v-model="Pending" /> -->
    </div>
    <v-navigation-drawer v-model="drawer" temporary right app>
      <v-list>

        <v-list-tile>
          <v-list-tile-content>
                    <v-list-tile-title v-if="this.userDisplayName!='Gäst'" flat  @click="logout_User()">
                         Logga ut
    </v-list-tile-title>
                        <v-list-tile-title v-else flat  to='/login' >
                        Logga in
    </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
      <!-- :class="[school ==null ? 'amber darken-2' : `${school.primary} lighten-2`]" -->

       <v-toolbar dark app 
      class="logo pencil2"

      >
        <v-toolbar-title class="headline text-uppercase ml-4 mt-n3" style="cursor:pointer" >
          <span class=" ml-2">EHT</span>
          <span class="font-weight-light">Kollen</span>
        </v-toolbar-title>
      <v-spacer>
    </v-spacer>    <h1 v-if="school!=null">{{school.name}}</h1>  
          <v-spacer>
    </v-spacer>
             <v-list-tile-action v-if="this.userDisplayName!='Gäst' ">
                     <v-icon  @click="Schedule=true" class="cog" color="white ligthen-1"
              >schedule</v-icon
            >
          </v-list-tile-action>
           <v-list-tile-action v-if="this.userDisplayName!='Gäst' && this.As!='admin'">
       <v-icon  @click="Setting=true" class="cog" color="white ligthen-1"
              >account_settings</v-icon
            >
          </v-list-tile-action>
                 <!-- <v-list-tile-action v-if="this.userDisplayName!='Gäst' && this.As!='admin'">
      
                 <v-badge
          color="blue"
          content="6"
          overlap
        >
         <v-icon  @click="Pending=true" class="cog" color="white ligthen-1"    >  
     
          pending_actions
      </v-icon>  </v-badge>
          </v-list-tile-action>   -->
      <h2 v-if="this.userDisplayName!='Gäst'"> {{this.userDisplayName}}</h2>
     
      <v-toolbar-items class="hidden-sm-and-down">
    <v-btn v-if="this.userDisplayName!='Gäst'" flat  @click="logout_User()">Logga ut</v-btn>
    <v-btn v-else flat  to='/login' >Logga in</v-btn>
        <!-- <v-btn flat v-for="item in menuItems" :key="item.id" :to="(item.to)">{{item.name}}</v-btn> -->

      </v-toolbar-items>
      <v-toolbar-side-icon class="hidden-md-and-up" @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
     <div class="" v-if='this.userDisplayName!=""'>

      <ModalIdle  :As="this.As"  v-if="isIdle"  v-model="isIdle" />
    </div> 
      <router-view />
    </v-content>
        <v-snackbar
      v-model="snackbarlocal"
      :timeout="snackbarTime"
      bottom
      :color="snackbarColor"
    >
      <span>{{ snackbarText }}</span>
      <v-btn color="white" flat @click="snackbarlocal = false">Stäng</v-btn>
    </v-snackbar>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import appFooter from './components/appFooter'

import ModalIdle from "./components/assets/ModalIdle";
import Settings from './components/Settings'
import Notification from './components/Notification'

import { mapGetters, mapActions } from 'vuex'
import Schedule from './components/Teacher/Schedule.vue';
export default {
  name: 'App',

 created () {
            document.title = "EHTKollen";
        },

  components: {
    'app-footer': appFooter,
    Settings,Notification,ModalIdle,
    Schedule

  },
  computed: {
   	isIdle() {
			return this.$store.state.idleVue.isIdle;
		},
    ...mapGetters('schools', ['school']),
    ...mapGetters([   "snackbar",
      "snackbarText", "snackbarTime",
      "snackbarColor",'userDisplayName','As']),
    snackbarlocal: {
      set(show) {
        this.SHOWSNACKBAR(show);
      },
      get() {
        return this.snackbar;
      },
    },
  },
  methods: {
    ...mapActions(['SHOWSNACKBAR']),
logout_User(){
  // let temp= this;
  //  (this.As)
  if (this.As=="teacher") {
    this.logoutTeacher();
    this.setUser(null);
  }
  else if (this.As=="EHT") {
    this.logoutEHT();
    this.logoutCases();
    this.setUser(null);
  }
  // else
  this.logoutMappings();
  this.logoutExtras();
  this.logoutUser();
  this.logoutSchool();
this.logoutclassesAP();
this.logoutWhistles();
this.logoutViolations();
this.logoutFeelings();
  //  temp.$router.replace('/login')
  this.$router.push('/')
},
    ...mapActions('teachers', ['logoutTeacher']),
    ...mapActions('extra', ['logoutExtras']),
    ...mapActions('ehtmembers', ['logoutEHT']),
    ...mapActions(['logoutUser','setUser']),
    ...mapActions('schools', ['logoutSchool']),
    ...mapActions('cases', ['logoutCases']),
    ...mapActions('classesAP', ['logoutclassesAP']),
    ...mapActions('mappings', ['logoutMappings']),
    ...mapActions('whistles', ['logoutWhistles']),
    ...mapActions('violations', ['logoutViolations']),
    ...mapActions('feeling', ['logoutFeelings']),
  },

  data () {
    return {
      drawer: null,
      Setting: false,
      Schedule:false,
      Pending: false,
      menuItems: [
        // { name: 'HOME', icon: 'home', to: '/' },
        // { name: 'teacher', icon: 'data_usage', to: '/teacher' },
        { name: 'Login', icon: 'data_usage', to: '/login' }
        // { name: 'FIREBASE AUTH', icon: 'supervisor_account', to: '/firebase-auth' }
      ]
    }
  }
}
</script>
<style src="./assets/styles/styleSheet.css"></style>
<style>

  /* .logo:before {
    content: '';
    position: absolute;
    left: -95px;
    top: 0px;
    width: 0;
    height: 0;
    content: url('https://i.ibb.co/VL7VLL4/tipsmall.png') ;
  } */
  

.logo {



  background-image:url('https://i.ibb.co/1L1qbzG/penmiddle.png');
  background-repeat: repeat-x;
  /* background-image:url('https://i.ibb.co/c8jY6jR/penshortpink.png'); */
  margin-left: 10%;
    margin-right: 10%;
    width: 80% !important;
  /* background-image:url('https://i.ibb.co/cCrFPfL/penshortpinkw12.png'); */
  /* background-image:url('https://i.ibb.co/Kxt3FhH/penshortpinkw122.png'); */

  /* background-image:url('https://i.ibb.co/ThgsVQj/penshortpinkw1.png'); */
/* background: linear-gradient(80deg, white 20%, #0000ff 0%); */
  /* background-image:url('https://i.ibb.co/c8jY6jR/penshortpink.png');  */

height: auto;  
}

.pencil2:after{
    top: 0px;
    position: absolute;
    right: -90px;
    content: url('https://i.ibb.co/sW2Msff/endsmall.png');
  
  }
  .pencil2:before {
    content: '';
    position: absolute;
    left: -95px;
    top: 0px;
    width: 0;
    height: 0;
    content: url('https://i.ibb.co/VL7VLL4/tipsmall.png') ;
  }
  

.elevation-1 tr th {
  background-color: #90CAF9;
  color: white !important;
  font-weight: bolder;
  font-size: medium;
}


.space{margin-left:5%}
.cog{
  padding: 0px;
  margin-right:10px;
  /* width: 30px; */
}
</style>